// extracted by mini-css-extract-plugin
module.exports = {"productMainInfo":"General_productMainInfo__1G0if"};